module.exports = __webpack_public_path__ + "img/referrals-selected-icon.88494b02.svg";